import { render, staticRenderFns } from "./NixiaChatInput.vue?vue&type=template&id=7ac4c892&scoped=true&"
import script from "./NixiaChatInput.vue?vue&type=script&lang=js&"
export * from "./NixiaChatInput.vue?vue&type=script&lang=js&"
import style0 from "./NixiaChatInput.vue?vue&type=style&index=0&id=7ac4c892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4c892",
  null
  
)

export default component.exports